<template>
  <div 
    v-if="visible" 
    :class="['spinner-container', { 'overlay': overlay }]"
    :style="containerStyles"
  >
    <div 
      :class="['spinner', `spinner--${variant}`]"
      :style="spinnerStyles"
    >
      <div class="spinner__circle"></div>
    </div>
    <p v-if="message" class="spinner__message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'AppSpinner',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    size: {
      type: [String, Number],
      default: 10,
      validator: value => !isNaN(value) && value > 0
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'white'].includes(value)
    },
    overlay: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    speed: {
      type: String,
      default: 'normal',
      validator: value => ['slow', 'normal', 'fast'].includes(value)
    }
  },
  computed: {
    containerStyles() {
      return this.overlay ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999
      } : {}
    },
    spinnerStyles() {
      const sizeValue = typeof this.size === 'number' ? `${this.size}px` : this.size
      const animationDuration = {
        slow: '2s',
        normal: '1s',
        fast: '0.5s'
      }[this.speed]

      return {
        width: sizeValue,
        height: sizeValue,
        '--animation-duration': animationDuration
      }
    }
  }
}
</script>

<style scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.spinner-container.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  position: relative;
  animation: spin var(--animation-duration, 1s) linear infinite;
}

.spinner__circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: currentColor;
  border-right-color: currentColor;
}

.spinner--primary {
  color: #007bff;
}

.spinner--secondary {
  color: #6c757d;
}

.spinner--white {
  color: #ffffff;
}

.spinner__message {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
  text-align: center;
}

.overlay .spinner__message {
  color: #ffffff;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>